import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/vehicleRegistration/task/page',
    method: 'post',
    data,
  })
}
export async function approval(data) {
  return request({
    url: '/vehicleRegistration/task/check',
    method: 'post',
    data,
  })
}
export async function revoke(data) {
  return request({
    url: '/vehicleRegistration/revoke',
    method: 'post',
    data,
  })
}
export async function checkUpdateField(data) {
  return request({
    url: '/vehicleRegistration/canAmend',
    method: 'post',
    data
  })
}
export async function updateAmend(data) {
  return request({
    url: '/vehicleRegistration/amend',
    method: 'post',
    data
  })
}